import React from 'react';
import useFetchTheatron from "../../hooks/useFetchTheatron";
import useTiming from "../../hooks/useTiming";

const DoorLayout = ({children}) => {
  const theatron = useFetchTheatron();
  const timing = useTiming();

  return (
    <div className="bg-curtain bg-overlay min-h-screen py-10">
      {/* <div className="w-2/3 md:w-72 m-auto logo logo-vw mb-10 bg-center" /> */}
      <div className="w-2/3 md:w-72 m-auto pb-8">
          <img src={timing?.venue?.logo || theatron.data?.logo} className="w-full h-full" />
      </div>
      {children}
    </div>
  )
}

export default DoorLayout;
